export default __webpack_public_path__ + "static/media/mode.651cf792.svg";